import type { RangeDataItem } from './types'

/**
 * Sanitizes RangeDataItem by converting ReactNode note values to undefined.
 * This ensures only string values are stored in the widget state.
 *
 * @param item - The RangeDataItem to sanitize
 * @returns A new RangeDataItem with ReactNode note values converted to undefined
 */
export function sanitizeRangeDataItem(item: RangeDataItem): RangeDataItem {
  return {
    ...item,
    note: typeof item.note === 'string' ? item.note : undefined,
  }
}

/**
 * Sanitizes an array of RangeDataItems by converting ReactNode note values to undefined.
 *
 * @param items - Array of RangeDataItems to sanitize
 * @returns A new array with sanitized RangeDataItems
 */
export function sanitizeRangeDataItems(
  items: RangeDataItem[] | undefined,
): RangeDataItem[] | undefined {
  return items?.map(sanitizeRangeDataItem)
}
